import { Component, EventEmitter, forwardRef, Input, Output, SkipSelf, ViewChild } from "@angular/core";
import { ControlContainer, ControlValueAccessor, NgModel, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AnessaTranslationService } from "../translation/anessa-translation.service";
import { ProjectCommunicationService } from "../../communication/project-comms.service";
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'validated-input',
  templateUrl: './validated-input.component.html',
  styleUrls: ['validated-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ValidatedInputComponent),
      multi: true
    },
  ],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]],
  }]
})
export class ValidatedInputComponent extends UserpilotReloader implements ControlValueAccessor {
  @ViewChild('value') valueControl?: NgModel;
  @Input() name = '';
  @Input() placeholder = '';
  @Input() fontSize = '';
  @Input() floatLabel = '';
  @Input() editable = true;

  // used for applying custom validation, defaults to @Input() name property if left blank
  @Input() validationID = '';
  // validation options
  @Input() enableNanValidation = true;
  @Input() enableNegativeValidation = true;

  @Output() valueChange = new EventEmitter<any>();

  valueDisplay = '';
  errorMessage = '';
  warningMessage = '';

  @Input() set setErrorMessage(message: string) {
    this.errorMessage = message;
  }
  @Input() set setWarningMessage(message: string) {
    this.warningMessage = message;
  }

  constructor(
    private projectCommService: ProjectCommunicationService,
    private translationService: AnessaTranslationService
  ) {
    super();
  }

  updateErrorMessage(data: { message: string, params: any }) {
    let tempMessage = this.translationService.get(data.message, data.params);
    if (tempMessage != '' && tempMessage != this.errorMessage) {
      this.projectCommService.postFromUnitValue(tempMessage, Date.now());
    }
    this.errorMessage = this.translationService.get(data.message, data.params);
  }

  valueChanged(newValue: string) {
    this.valueChange.emit(newValue);
    this.onChangeCallback(newValue);
    this.updateValueValidity();
  }

  updateValueValidity() {
    if (this.valueControl && this.valueControl.control) {
      this.valueControl.control.updateValueAndValidity({ onlySelf: true });
      this.touchValueControl();
    }
  }

  touchValueControl() {
    if (this.valueControl && this.valueControl.control) {
      this.valueControl.control.markAsTouched();
    }
  }

  // ControlValueAccessor functions
  writeValue(inputValue: any) {
    if (inputValue !== null && inputValue !== "") {
      this.valueDisplay = inputValue;
    }
  }

  registerOnTouched(fn: any): void {}

  private onChangeCallback = (value: any) => {};

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

}
